import React from 'react'
import i18next from 'i18next'
import { useLocation } from 'react-router-dom'
import { useAppTranslation } from '@hooks/useAppTranslation'
import { DrawerContentBody, DrawerContentFooter, DrawerContentHeader } from '@components/ui-css/Drawer/Drawer'
import { CssModuleContext } from '@components/stylesContext/context'
import { InteractionContext } from '@components/interactionContext/context'
import { SVGIcon } from '@components/ui-css/SVGIcon/SVGIcon'
import { ErrorCTA } from './components/ErrorCTA'
import { ContactUsPanel } from './components/ContactUsPanel'
import { ErrorPageState } from './types'
import styles from './styles/Error.module.scss'

const Error: React.FC = () => {
  const { t } = useAppTranslation({ keyPrefix: 'ErrorPage' })
  const location = useLocation()

  const state: ErrorPageState = location.state
  const { errorType, title, message, ctaLabel } = state ?? {}

  const keyForError = errorType ? `body.content-${errorType}` : 'body.content'

  return (
    <InteractionContext.Provider value={{ name: 'insurance-panel', type: 'technical-error' }}>
      <CssModuleContext.Provider value={styles}>
        <DrawerContentHeader>
          <span className={styles.title}>{title ?? t('header.title')}</span>
        </DrawerContentHeader>
        <DrawerContentBody className={styles.bodyContainer}>
          <div className={styles.body}>
            <SVGIcon library="base" name="clock" />
            <span className={styles.content}>{message ?? t(keyForError, t('body.content'))}</span>
            <ErrorCTA ctaLabel={ctaLabel} />
          </div>
          <DrawerContentFooter noGutter className={styles.nonStickyFooter}>
            <div className={styles.footer}>
              <ContactUsPanel />
              <span className={styles.disclaimer}>{t('footer.disclaimer')}</span>
            </div>
          </DrawerContentFooter>
        </DrawerContentBody>
        <DrawerContentFooter className={styles.stickyFooter}>
          <div className={styles.footer}>
            <ContactUsPanel />
            <span className={styles.disclaimer}>{t('footer.disclaimer')}</span>
          </div>
        </DrawerContentFooter>
      </CssModuleContext.Provider>
    </InteractionContext.Provider>
  )
}

export default Error
